import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { HomeDropZone } from "#modules/quoteRequestLines/HomeDropZone";
import { usePredictParts } from "#modules/quoteRequestLines/usePredictParts";
import { useValidFilesTypes } from "#modules/quoteRequestLines/useValidFileTypes";
import { useAnalytics, AnalyticsEvent } from "#shared/useAnalytics";
import { Flex } from "#shared/view/components/Flex";
import { Stack } from "#shared/view/components/Stack";
import { UPLOAD_CONFIG } from "shared";

import classes from "./PredictDropzone.module.css";

export const PredictDropzone = ({ onSuccess }: { onSuccess: (quoteRequestId: string) => void }) => {
  const analytics = useAnalytics();
  const { onDropFile, progress, isPending } = usePredictParts({
    onSuccess,
    currentQuoteRequestLineIndex: 0,
  });

  const { validExtensions, accept } = useValidFilesTypes("predict");

  return (
    <Flex gap="xl">
      <Stack className={`${classes.search!} ${classes.panel!}`}>
        <HomeDropZone
          title={t("qr.dropzone.start_predict")}
          loading={isPending && !progress}
          multiple={true}
          illustration="/images/predict.png"
          onDrop={async (files) => {
            analytics.capture(AnalyticsEvent.UserDropFile, { workflow: "prediction" });
            await onDropFile(files);
          }}
          classes={classes}
          uploadProgress={progress}
          progressBarColor={colors.violet[5]}
          validFileTypeText={t("qr.dropzone.launch_predict")}
          validExtensions={validExtensions}
          accept={accept}
          maxSize={UPLOAD_CONFIG.PART.maxFileSize}
        />
      </Stack>
    </Flex>
  );
};
